import React, {Fragment} from 'react';

import {
    SimpleForm,
    Edit,
    Create,
    TextInput,
    SelectInput,
    required,
    ReferenceInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import Avatar from "@material-ui/core/Avatar";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import PersonIcon from '@material-ui/icons/Person';
import simpleMemoize from "../../framework/util/forms/SimpleMemoize";
import * as yup from 'yup';
import {yupValidate} from "../../framework/util/forms/YupValidationWithRFF";
import PeopleStore from "../stores/PeopleStore";

const checkDupId = function (value) {
    return new Promise((resolve, reject) => {
        new PeopleStore().findById(value).then((data) => {
            // exists
            resolve(false)
        }).catch(() => {
            // note exists
            resolve(true)
        })
    })
};

const validationSchemaCreate = yup.object({
    id: yup.string().required().test('checkDupId', 'Id already exists', checkDupId),
    siteId: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    shift: yup.string().required(),
});

const validationSchemaEdit = yup.object({
    id: yup.string().required(),
    siteId: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    shift: yup.string().required(),
});





const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const idUnique = simpleMemoize(async value => {
    if (!value) {
        return "Required";
    }
    try {
        const existing = await new PeopleStore().findById(value);
        if (existing) {
            return "Already taken!";
        }
    }
    catch(error) {
        // Ignore
    }
});



const IdInput = (props) => {
    return (
        <TextInput
            label="Employee Id"
            source="id"
            variant='outlined'
            helperText={'A unique identifier for employees'}
            disabled={props.disabled}
        >
        </TextInput>);
}

const FirstNameInput = (props) => {
    return (
        <TextInput
            label="First Name"
            source="firstName"
            variant='outlined'
            helperText={''}
        >
        </TextInput>);
}

const LastNameInput = (props) => {
    return (
        <TextInput
            label="Last Name"
            source="lastName"
            variant='outlined'
            helperText={''}
        >
        </TextInput>);
}

const ShiftInput = (props) => {
    return (
        <TextInput
            label="Shift"
            source="shift"
            variant='outlined'
            helperText={'Shift name or number'}
        >
        </TextInput>);
}

const CategoryInput = (props) => {
    return (
        <TextInput
            label="Category"
            source="category"
            variant='outlined'
            helperText={'Am optional category such as temp, contract etc'}
        >
        </TextInput>);
}


const SiteChooser = (props) => {
    return (
        <ReferenceInput
            label="Site"
            source="siteId"
            reference="site"
            variant='outlined'
            validate={required()}

        >
            <SelectInput
                helperText={'Site where operator is located'}
                optionText={(record) => {
                    return record.id + ' - ' + record.name
                }}
            />
        </ReferenceInput>);
}

const PostTitle = ({ record }) => {
    return <span>{record ? ` - ${record.firstName} ${record.lastName}` : ''}</span>;
};

const Header = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <PersonIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
                Operator Setup
            </Typography>
            <br/>
            <Typography component="h5">
                Configure operator settings to allow them to check in to production activities.
            </Typography>
        </div>
    );
}


const FormContentsCreate = (props) => {
    return (
        <SimpleForm {...props} validate={yupValidate(validationSchemaCreate)}  redirect="list">
            <SiteChooser/>
            <IdInput/>
            <FirstNameInput/>
            <LastNameInput />
            <ShiftInput />
            <CategoryInput />
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}

const FormContentsEdit = (props) => {
    return (
        <SimpleForm {...props} validate={yupValidate(validationSchemaEdit)}  redirect="list">
            <SiteChooser/>
            <IdInput disabled/>
            <FirstNameInput/>
            <LastNameInput />
            <ShiftInput />
            <CategoryInput />
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}


export const PeopleEditCommon = ({record, ...props}) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Edit {...props} title={<PostTitle/>}>
                <FormContentsEdit {...props}/>
            </Edit>

        </div>
    );
}

export const PeopleCreateCommon = (props) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Create {...props} title={<PostTitle/>}>
                <FormContentsCreate {...props}/>
            </Create>

        </div>
    );
}
